import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "assets-card-wr" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "assets-img-wr" }
const _hoisted_7 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString($setup.props.asset?.name), 1),
      _createElementVNode("button", {
        class: "button default edit edit-icon",
        onClick: $setup.openModal
      }),
      _createElementVNode("button", {
        class: "button button-with-icon trash-icon",
        onClick: $setup.deleteAsset
      }, [
        _createElementVNode("img", {
          class: "trash-icon-img",
          src: require(`@/assets/icons/trash.svg`)
        }, null, 8, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, _toDisplayString($setup.formatPriceTrim($setup.props.asset?.price)), 1),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("img", {
        class: "assets-img",
        src: $setup.props.asset?.url ?? $setup.props.asset?.imagesUrls[0]
      }, null, 8, _hoisted_7)
    ]),
    _createVNode($setup["AddAndUpdateAssetInGalleryModal"], {
      isOpen: $setup.assetGalleryModalOpen,
      builderId: $setup.props.builderId,
      formType: $setup.props.formType,
      title: $setup.props.title,
      asset: $setup.props.asset,
      uploadImage: $setup.props.uploadImage,
      mode: "update",
      canUploadMultipleImages: true,
      onConfirm: _cache[0] || (_cache[0] = ($event: any) => ($setup.reloadAssetGallery = true)),
      onClose: _cache[1] || (_cache[1] = ($event: any) => ($setup.assetGalleryModalOpen = false)),
      onCreateFacade: $setup.handleCreateFacade,
      onUpdateFacade: $setup.handleUpdateFacade,
      onCreateExternalColorScheme: $setup.handleCreateExternalColorScheme,
      onUpdateExternalColorScheme: $setup.handleUpdateExternalColorScheme,
      onCreateInternalColorScheme: $setup.handleCreateInternalColorScheme,
      onUpdateInternalColorScheme: $setup.handleUpdateInternalColorScheme,
      onCreateOptionalUpgrade: $setup.handleCreateOptionalUpgrade,
      onUpdateOptionalUpgrade: $setup.handleUpdateOptionalUpgrade
    }, null, 8, ["isOpen", "builderId", "formType", "title", "asset", "uploadImage"])
  ]))
}